export const enum LOG_NAME {
  getAttendancePolicies = 'getAttendancePolicies',
}

export const enum LOG_TYPE {
  error = 'error',
  timeout = 'timeout'
}

export function getLogName(name: LOG_NAME, type: LOG_TYPE) {
  return `${name}_${type}`;
}
